import { IReferenceTimeZoneDTO } from "../../../services/global-data-service/Models";
import { IReportNotificationSummaryDTO, IReportScheduleSummaryDTO, ReportDeliveryType } from "../../../services/reporting-data-service/ReportScheduleModels";
import { IReferenceNotificationListDTO } from "../../../services/setpoint-administration-service/Models";
import { ReportScheduleFormType, ReportScheduleRecipientType } from "../ScheduledReportsEditorUtils";

const ScheduledReportsSummaryUtils = {

    mapToNotificationSummaryModel: function(recipients: ReportScheduleRecipientType[],
        notificationLists: IReferenceNotificationListDTO[]): IReportNotificationSummaryDTO[] {

        let notifications: IReportNotificationSummaryDTO[] = recipients.filter(o => o.selected).map(o => {
            return {
                id: o.id,
                deliveryType: ReportDeliveryType.Email,
                displayText: o.address
            
            } as IReportNotificationSummaryDTO
        });


        notifications = notifications.concat(notificationLists.filter(o =>  o.selected).map(o => {
            return {
                id: o.id,
                deliveryType: ReportDeliveryType.NotificationList,
                displayText: o.name
            } as IReportNotificationSummaryDTO
        }));

        return notifications;
    },
    mapToScheduleSummaryModel: function(schedules: ReportScheduleFormType[],
        timezones: IReferenceTimeZoneDTO[]) {

        return schedules.map((o) => {

            return {
                id: o.id,
                description: o.description,
                frequency: o.repeatRange,
                repeatInterval: o.repeatInterval,
                isActive: o.isActive,
                timezoneIndex: o.timezoneIndex,
                timezoneName: timezones?.find(v => v.id === o.timezoneIndex)?.name,
                dayOfMonth: o.dayOfMonth,
                dayOfWeek: o.dayOfWeek,
                hour: o.hour,
                minute: o.minute,

                frequencyOption: o.frequencyOption,
                
    
        } as IReportScheduleSummaryDTO
    });
    }

}

export default ScheduledReportsSummaryUtils;


